module.exports = __webpack_public_path__ + "src/img/downward_green.6fa5a89d.svg";